export default "__VITE_ASSET__BYFWA1gm__"